import request from "utils/request";
import { baseRequestURL, constructQueryParams } from "api/BaseAPI";

export function getFolders() {
  return request(baseRequestURL + "v1/folders", {
    method: "GET"
  }).then((response) => response);
}

export function getFolder(id) {
  return request(baseRequestURL + "v1/folders/" + id, {
    method: "GET"
  }).then((response) => response);
}

export function createFolder(name, description, collaborators, defaultRoleType) {
  return request(baseRequestURL + "v1/folders/", {
    method: "POST",
    body: JSON.stringify({
      name,
      roles: collaborators,
      description,
      default_role_type: defaultRoleType
    })
  }).then((response) => response);
}

export function patchFolder(id, data) {
  return request(baseRequestURL + "v1/folders/" + id, {
    method: "PATCH",
    body: JSON.stringify({ ...data })
  }).then((response) => response);
}

export function deleteFolder(id) {
  return request(baseRequestURL + "v1/folders/" + id, {
    method: "DELETE"
  }).then((response) => response);
}

export function addUserRoleToFolder(folderId, user, role, params) {
  const payload = {
    role_user: user.id,
    role_type: role
  };

  if (payload.id === undefined) {
    payload.role_user_email = user.email;
    delete payload.id;
  }

  let retParams = params;

  if (typeof params !== "string") {
    retParams = constructQueryParams(params);
  }

  return request(baseRequestURL + "v1/folders/" + folderId + "/roles" + (retParams ? retParams : ""), {
    method: "POST",
    body: JSON.stringify({
      role_user: user.id,
      role_user_email: user.email,
      role_type: role
    })
  }).then((response) => response);
}

export function deleteUserRoleFromFolder(folderRoleId) {
  return request(baseRequestURL + "v1/folder_roles/" + folderRoleId, {
    method: "DELETE"
  }).then((response) => response);
}

export function patchUserRoleFolder(folderRoleId, role) {
  return request(baseRequestURL + "v1/folder_roles/" + folderRoleId, {
    method: "PATCH",
    body: JSON.stringify({
      role_type: role
    })
  }).then((response) => response);
}
